// extracted by mini-css-extract-plugin
module.exports = {"tooltipIcon":"src-components-InputTooltip-InputTooltip-module__tooltipIcon--3Ta46"};